import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MessagesModule } from 'primeng/messages';
import { ToastMessageOptions } from 'primeng/api';
import { Subscription } from 'rxjs';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-notification-banner',
  standalone: true,
  imports: [CommonModule, MessagesModule],
  template: `
    <div class="notification-banner" *ngIf="messages.length > 0" (click)="onClick($event)">
      <p-messages
        [value]="messages"
        [closable]="true"
        [enableService]="false"
        [escape]="false"
        (onClose)="onClose($event)">
      </p-messages>
    </div>
  `,
  styles: [`
    .notification-banner {
      width: 100%;
      padding: 0.75rem 1rem;
      border: 1px solid var(--p-surface-300);
      border-radius: 6px;
      background: var(--p-surface-50);
      margin: 0.5rem 0;
    }
    :host-context(.app-dark) .notification-banner {
      border-color: var(--p-surface-600);
      background: var(--p-surface-800);
    }
    :host ::ng-deep .notification-banner a {
      color: var(--p-primary-color);
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
    }
    :host ::ng-deep .notification-banner a:hover {
      text-decoration: none;
    }
  `]
})
export class NotificationBannerComponent implements OnInit, OnDestroy {
  messages: ToastMessageOptions[] = [];
  private subscription!: Subscription;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications$.subscribe(
      notifications => this.messages = notifications
    );
  }

  /** Intercept <a> clicks inside the banner and use Angular router instead of full page reload */
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      const href = target.getAttribute('href');
      if (href && href.startsWith('/')) {
        event.preventDefault();
        const currentPath = this.router.url.split('?')[0];
        const targetPath = href.split('?')[0];
        if (currentPath === targetPath) {
          // Same route: bounce through '/' to force component re-initialization
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(href);
          });
        } else {
          this.router.navigateByUrl(href);
        }
      }
    }
  }

  onClose(event: ToastMessageOptions): void {
    if (event.id) {
      this.notificationService.remove(event.id);
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
